import React from "react";
import { connect } from "react-redux";
import throttle from "throttleit";

import { isShopReady } from "state/school_money/selectors";
import { markStudentShopItemsAsSeen,setShopItemSearchQuery } from "state/school_money/actions";

import SearchBar from "components/SearchBar";
import MaintainValidStudentID from "components/school_money/MaintainValidStudentID";
import Preloader from "components/school_money/Preloader";
import StudentSelector from "components/school_money/StudentSelector";
import StudentCarousel from "components/school_money/StudentCarousel";
import StudentShopItemList from "components/school_money/shop/StudentShopItemList";

import "./ShopPage.css";

const INPUT_THROTTLE_DELAY = 500;

class ShopPage extends React.Component {

  // initialise state
  state = {
    searchQuery: ""
  }

  /**
   * Update the global state using a throttle
   */
  setGlobalSearchQueryState = throttle((searchQuery) => {
    this.props.setShopItemSearchQuery(searchQuery);
  }, INPUT_THROTTLE_DELAY);

  onSearch = (searchQuery) => {
    this.setState({ searchQuery });
    this.setGlobalSearchQueryState(searchQuery);
  };

  generatePath = (studentID) => {
    return `/school_money/shop/${studentID}/`;
  }

  onStudentChange = (studentID, prevStudentID) => {
    this.props.markStudentShopItemsAsSeen(prevStudentID);
  }

  componentWillUnmount() {
    this.props.markStudentShopItemsAsSeen(this.props.match.params.studentID);
  }

  render() {

    const { studentID } = this.props.match.params;
    const { searchQuery } = this.state;

    return (
      <MaintainValidStudentID currentStudentID={studentID} generatePath={this.generatePath}>
        <Preloader isPageReady={isShopReady}>
          <div className="shop-page">
            <div className="page-header">
              <div className="page-header__title">Shop</div>
              <StudentSelector selectedStudentID={studentID} generatePath={this.generatePath} />
            </div>
            <SearchBar onSearch={this.onSearch} query={searchQuery} />
            <StudentCarousel activeStudentID={studentID} generatePath={this.generatePath} onChange={this.onStudentChange}>
              { studentID => <StudentShopItemList key={studentID} studentID={studentID} /> }
            </StudentCarousel>
          </div>
        </Preloader>
      </MaintainValidStudentID>
    );

  }

}

export default connect(
  undefined,
  { markStudentShopItemsAsSeen, setShopItemSearchQuery }
)(ShopPage);



// WEBPACK FOOTER //
// ./src/components/school_money/shop/ShopPage.js